import React from 'react';
import StyledButton from '../../../../shared/components/styledButton/styledButton';
import i18n from '../../../../utils/i18n';
// import NeedHelp from '../contactInfo/needHelp';

const Navigation = ({ handleBack, handleNext, step, disabledProp }) => {
	//console.log(step, 'SZTEP');
	return (
		<div
			className={`SFButtonContainer ${
				step === 13 ? 'SFResultNavContainer' : ''
			}`}
			style={{
				justifyContent: 'space-between',
				//step !== 0 && window.innerWidth > 600 ? 'space-between' : 'center',
			}}>
			<div>
				<StyledButton
					className='btnMaxWidth130 Medium '
					color='NewNavBack'
					onClick={() => {
						step === 0
							? window.location.replace('https://ro.bookkeepie.com/')
							: handleBack();
					}}>
					{step !== 0
						? i18n.t('general.backbutton')
						: i18n.t('providerdashboard.undo')}
				</StyledButton>
			</div>
			{step !== 13 && (
				<StyledButton
					className='btnMaxWidth130 Medium'
					color='NewNavForward'
					onClick={() => {
						handleNext();
					}}
					isDisabled={disabledProp}>
					{i18n.t('general.forwardbutton')}
				</StyledButton>
			)}
			{step === 13 && null}
		</div>
	);
};

export default Navigation;
